export default __webpack_public_path__ + "static/media/testedandtrusted.1f987873.png";